import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

export const useNavigationV2Enabled = (): boolean => {
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  return Boolean(layoutData?.community?.navigation_v2_enabled);
};
